export enum Variant {
  Default,
  Compact,
  CompactReverse,
}
